import { useShowLoginOrSignUpModal } from 'src/auth/modal/useShowLoginOrSignUpModal';
import { ExitIntentKey, useSignupModalExitIntent } from 'src/pages/consumer/exit-intent-modals/useShefExitIntent';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useLocation } from 'src/shared/hooks/useLocation';
import { Routes } from 'src/shared/Routes';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { useGetSignupPromo } from './useGetSignupPromo';

// If you want the exit intent to show up on a certain page, add it to this array
const PAGES_TO_TRIGGER = [Routes.CONSUMER_ORDER_ONE_TIME, Routes.CONSUMER_LANDING];

export const useFirstTimeExitIntent = () => {
  const [currentUser] = useCurrentUser();
  const location = useLocation();
  const { registerHandler, isUnsubscribed } = useSignupModalExitIntent();
  const isTriggerPage = locationInRoutes(location, PAGES_TO_TRIGGER);
  const { show: showLoginOrSignUpModal } = useShowLoginOrSignUpModal();
  const { signupPromo } = useGetSignupPromo();
  const canUsePromoCode = !currentUser && isTriggerPage && Boolean(signupPromo);

  registerHandler({
    id: 'openModal',
    handler: () => {
      if (canUsePromoCode && !isUnsubscribed) {
        showLoginOrSignUpModal({
          signUpPromoCode: signupPromo,
          onHideModalKey: ExitIntentKey.FIRST_TIME_USER_SIGNUP_MODAL,
          signUpEntryPoint: 'exit_intent_modal',
        });
      }
    },
  });

  return null;
};
